<template>
  <div class="filter-wrapper">
    <v-row>
      <v-col cols="4">
        <AutocompleteClass
          v-model="selectedClass"
          clear-icon="mdi-close"
          label="Lớp"
          outlined
          dense
          required
          hide-details
        />
      </v-col>
      <v-col cols="4">
        <AutocompleteStudent
          v-model="selectedStudent"
          label="Học viên"
          outlined
          dense
          :filter="selectedClass ? { currentClass: selectedClass.id } : {}"
          hide-details
        />
      </v-col>
    </v-row>
    <div>
      <v-btn class="search-button" @click="onFilterChanged" outlined> Tìm kiếm </v-btn>
    </div>
  </div>
</template>

<script>
import AutocompleteClass from '@/components/basic/input/AutocompleteClass.vue'
import AutocompleteStudent from '@/components/basic/input/AutocompleteStudent.vue'
import { mapActions, mapMutations } from 'vuex'

export default {
  components: {
    AutocompleteClass,
    AutocompleteStudent,
  },
  data: () => ({
    selectedClass: null,
    selectedStudent: null,
  }),
  methods: {
    ...mapActions({
      findStatsAttendance: 'lessonAttendance/findStatsAttendance',
    }),
    ...mapMutations({
      setLoading: 'lessonAttendance/setLoading',
    }),
    async onFilterChanged() {
      try {
        this.setLoading(true)
        const params = {}
        if (this.selectedClass) params.class = this.selectedClass.id
        if (this.selectedStudent) params.student = this.selectedStudent.id
        await this.findStatsAttendance(params)
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.setLoading(false)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
}
</style>
